module.exports = __webpack_public_path__ + "static/media/logo-new.b6f42f67.png";